// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-tabs .nav-link {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 2px solid #3545ee !important;
  border-radius: 20px !important;
  background: #ffffff !important;
  font-style: normal;
  font-weight: 600;
  color: black;
}

.profile-tabs .nav-item .active {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 2px solid #3545ee !important;
  border-radius: 20px !important;
  background: #3545ee !important;
  color: #ffffff;
}

.otp-input-box {
  display: flex;
  justify-content: center;
}

.otp-input-box > input {
  border-radius: 10px;
  border: 1px solid black;
  height: 50px !important;
  width: 50px !important;
  -webkit-text-security: square;
}

.navProfile {
  display: flex;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.tabs-navigator .nav-tabs .nav-link {
  white-space: nowrap;
  color: #6f7182;
  font-family: "Inter", Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  border: none;
  display: flex;
  align-items: center;
  gap: 5px;
}

.tabs-navigator .nav-tabs .nav-link.active,
.tabs-navigator .nav-tabs .nav-link:focus {
  background-color: transparent !important;
  border: none !important;
  color: #1476ff !important;
}

.text-danger-error {
  font-family: "Inter", Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}

.modalEditPic {
  /* width: 475px; */
  height: 225px;
  border-radius: 1.75rem;
  box-shadow: 0px 2px 10px 0px #195dc212;
}

.modalTitleWidth {
  margin: 0 auto;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  text-align: justified;
}

.modal-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 100vh; */
}

.modalEditPic > .modal-dialog > .modal-content {
  width: 350px;
  border-radius: 1.5rem;
  box-shadow: 0px 2px 10px 0px #195dc212;
}

.modal-header .btn-close {
  margin: 0;
}

.editProfilepicbtn {
  background: #1476ff;
  width: 70%;
  height: 20px;
  padding: 20px 13px;
  border-radius: 18px;
  color: #ffffff;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  text-align: justified;
}

.editProfilepicbtn:hover {
  cursor: pointer;
}

::-webkit-scrollbar {
  display: none;
}

.profile-select {
  border: 1px solid rgb(233, 234, 243);
  box-shadow: rgb(233, 234, 243) 0px 0px 10px;
  border-radius: 30px;
  /* padding: 5px */
}

.selct-drop-profile .css-1fdsijx-ValueContainer {
  padding: 2px 20px !important;
}

.profEmail {
  box-shadow: rgb(233, 234, 243) 0px 0px 10px;
  border-radius: 52px;
}

.faded-text {
  color: #1476ff;
  opacity: 0.5;
  pointer-events: none;
  font-size: 12px;
  font-weight: 600;
}

@media screen and (max-width: 500px) {
  .flex_grow {
    flex-grow: 1;
  }
}
@media screen and (max-width: 450px) {
  .tabs-navigator .nav-tabs .nav-link {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProfileNew/Profile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,wCAAwC;EACxC,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".profile-tabs .nav-link {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid #3545ee !important;\n  border-radius: 20px !important;\n  background: #ffffff !important;\n  font-style: normal;\n  font-weight: 600;\n  color: black;\n}\n\n.profile-tabs .nav-item .active {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid #3545ee !important;\n  border-radius: 20px !important;\n  background: #3545ee !important;\n  color: #ffffff;\n}\n\n.otp-input-box {\n  display: flex;\n  justify-content: center;\n}\n\n.otp-input-box > input {\n  border-radius: 10px;\n  border: 1px solid black;\n  height: 50px !important;\n  width: 50px !important;\n  -webkit-text-security: square;\n}\n\n.navProfile {\n  display: flex;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.tabs-navigator .nav-tabs .nav-link {\n  white-space: nowrap;\n  color: #6f7182;\n  font-family: \"Inter\", Arial, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.tabs-navigator .nav-tabs .nav-link.active,\n.tabs-navigator .nav-tabs .nav-link:focus {\n  background-color: transparent !important;\n  border: none !important;\n  color: #1476ff !important;\n}\n\n.text-danger-error {\n  font-family: \"Inter\", Arial, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.modalEditPic {\n  /* width: 475px; */\n  height: 225px;\n  border-radius: 1.75rem;\n  box-shadow: 0px 2px 10px 0px #195dc212;\n}\n\n.modalTitleWidth {\n  margin: 0 auto;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 32px;\n  text-align: justified;\n}\n\n.modal-dialog {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* height: 100vh; */\n}\n\n.modalEditPic > .modal-dialog > .modal-content {\n  width: 350px;\n  border-radius: 1.5rem;\n  box-shadow: 0px 2px 10px 0px #195dc212;\n}\n\n.modal-header .btn-close {\n  margin: 0;\n}\n\n.editProfilepicbtn {\n  background: #1476ff;\n  width: 70%;\n  height: 20px;\n  padding: 20px 13px;\n  border-radius: 18px;\n  color: #ffffff;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 32px;\n  text-align: justified;\n}\n\n.editProfilepicbtn:hover {\n  cursor: pointer;\n}\n\n::-webkit-scrollbar {\n  display: none;\n}\n\n.profile-select {\n  border: 1px solid rgb(233, 234, 243);\n  box-shadow: rgb(233, 234, 243) 0px 0px 10px;\n  border-radius: 30px;\n  /* padding: 5px */\n}\n\n.selct-drop-profile .css-1fdsijx-ValueContainer {\n  padding: 2px 20px !important;\n}\n\n.profEmail {\n  box-shadow: rgb(233, 234, 243) 0px 0px 10px;\n  border-radius: 52px;\n}\n\n.faded-text {\n  color: #1476ff;\n  opacity: 0.5;\n  pointer-events: none;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n@media screen and (max-width: 500px) {\n  .flex_grow {\n    flex-grow: 1;\n  }\n}\n@media screen and (max-width: 450px) {\n  .tabs-navigator .nav-tabs .nav-link {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
